import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

import { ClickEventTypes, HelpGenericEvents, NO_CATEGORY } from './constants'

export const sendOnClickCategory = ({
	categoryName,
	fromInsideCategory,
}: {
	categoryName: string
	fromInsideCategory?: boolean
}) => {
	sendGenericEvent(HelpGenericEvents.CLICK_CATEGORY, {
		action: fromInsideCategory
			? ClickEventTypes.CLICK_INSIDE
			: ClickEventTypes.CLICK_OUTSIDE,
		category_type: categoryName,
	})
}

export const sendOnClickQuestion = ({
	categoryName,
	questionName,
	fromInsideQuestion,
}: {
	categoryName: string
	questionName: string
	fromInsideQuestion?: boolean
}) => {
	sendGenericEvent(HelpGenericEvents.CLICK_QUESTION, {
		action: fromInsideQuestion
			? ClickEventTypes.CLICK_INSIDE
			: ClickEventTypes.CLICK_OUTSIDE,
		question_type: questionName,
		category_type: categoryName,
	})
}

export const sendOnClickFAQ = ({ questionName }: { questionName: string }) => {
	sendOnClickQuestion({ questionName, categoryName: NO_CATEGORY })
}

export const sendOnClickButtonFromQuestion = ({
	categoryName,
	questionName,
	buttonName,
}: {
	categoryName: string
	questionName: string
	buttonName: string
}) => {
	sendGenericEvent(HelpGenericEvents.CLICK_QUESTION_BTN, {
		type: buttonName,
		question_type: questionName,
		category_type: categoryName,
	})
}

export const sendOnClickContactButton = ({
	categoryName,
	questionName,
}: {
	categoryName?: string
	questionName?: string
}) => {
	sendGenericEvent(HelpGenericEvents.CLICK_CONTACT_BTN, {
		...(categoryName && { category_type: categoryName }),
		...(questionName && { question_type: questionName }),
	})
}

export const sendOnClickContactLabel = ({
	label,
	categoryName,
	questionName,
}: {
	// TODO: Type with the list of available contact methods when contact page is migrated
	label: string
	categoryName?: string
	questionName?: string
}) => {
	sendGenericEvent(`${HelpGenericEvents.CLICK_CONTACT_LABEL}${label}`, {
		...(categoryName && { category_type: categoryName }),
		...(questionName && { question_type: questionName }),
	})
}
